import * as Pikaday from "pikaday";
import * as moment from "moment";

declare const jQuery: any;
const $ = jQuery;

type JQuery = any;

export function initDateInputs($wrap?): void
{
    $wrap = $wrap || $(document.body);
    $wrap.find(`input[type="date"]`).each(function () {
        initDateInput($(this));
    });
}

export function initDateInput($origDateInput: JQuery): void
{
    $origDateInput.css({ display: "none" });
    const origDateInput: HTMLElement = $origDateInput[0];
    const $displayInput = $(`<input type="text" data-display-only="" />`).insertAfter(origDateInput).attr("placeholder", $origDateInput.attr("placeholder") || "");
    const displayTextInput: HTMLInputElement = $displayInput[0];
	const picker: Pikaday = new Pikaday({
		field: displayTextInput,
        format: "YYYY-MM-DD",
        onSelect(date): void {
            const m = moment(date);
            const dateInputFormatted: string = m.format("YYYY-MM-DD");
            $origDateInput.val(dateInputFormatted);
        },
        toString(date): string {
            const m = moment(date);
            const dateInputFormatted: string = m.format("DD/MM/YYYY");
            return dateInputFormatted;
        }
    });
}
